export const EXCMDEVICEPERIPHERAL_DELETE_RESET = 'EXCMDEVICEPERIPHERAL_DELETE_RESET'
export const EXCMDEVICEPERIPHERAL_DELETE_SET_ERROR = 'EXCMDEVICEPERIPHERAL_DELETE_SET_ERROR'
export const EXCMDEVICEPERIPHERAL_DELETE_SET_DELETED = 'EXCMDEVICEPERIPHERAL_DELETE_SET_DELETED'
export const EXCMDEVICEPERIPHERAL_DELETE_TOGGLE_LOADING = 'EXCMDEVICEPERIPHERAL_DELETE_TOGGLE_LOADING'
